import { createTheme } from '@mui/material';
import { yellow, cyan } from '@mui/material/colors';

export const LightTheme = createTheme({
    palette: {
        primary: {
            main: yellow[700],
            dark: yellow[800],
            light: yellow[500],
            contrastText: '#000000',
        },
        secondary: {
            main: '#000000',
            dark: cyan[400],
            light: cyan[300],
            contrastText: '#ffffff',
        },
        background: {
            paper: '#f9f9f9',
            default: '#f7f6f3'
        },
    },
    typography: {
        subtitle1: {
            color: 'black',
        }
    }
});